import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  disabled: {
    opacity: 0.5
  },
  input: {
    width: '80px'
  },
  item: {
    cursor: 'pointer',
    marginLeft: '30px'
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-h3': {
      marginLeft: '10px',
      maxWidth: '340px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis'
    },
    '& .MuiTypography-h5': {
      marginLeft: '10px'
    }
  },
  warning: {
    marginLeft: '4px'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  footerButton: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  sliderWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px'
  },
  slider: {
    margin: '0 10px'
  }
}));
export default useStyles;